import { render, staticRenderFns } from "./headerImage.vue?vue&type=template&id=0ef172e7&"
import script from "./headerImage.vue?vue&type=script&lang=js&"
export * from "./headerImage.vue?vue&type=script&lang=js&"
import style0 from "./headerImage.vue?vue&type=style&index=0&id=0ef172e7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports